import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { TextField, Button } from '@orijinworks/frontend-commons';

const NewResourceForm = ({ form, onChange, onSubmit, loading }) => (
  <Box
    data-testid="new-resource-form"
    style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
  >
    <TextField
      label="Course name"
      required
      fullWidth
      value={form.name}
      onChange={(e) => onChange({ ...form, name: e.target.value })}
      data-testid="new-resource-name"
    />
    <TextField
      label="External ID (optional)"
      fullWidth
      value={form.externalId}
      onChange={(e) => onChange({ ...form, externalId: e.target.value })}
      data-testid="new-resource-external-id"
    />
    <TextField
      label="Description (optional)"
      fullWidth
      multiline
      rows={2}
      value={form.description}
      onChange={(e) => onChange({ ...form, description: e.target.value })}
      data-testid="new-resource-description"
    />
    <Box>
      <Button
        color="primary"
        variant="contained"
        disabled={loading || !form.name?.trim()}
        onClick={onSubmit}
        data-testid="create-and-link-btn"
      >
        Create &amp; link
      </Button>
    </Box>
  </Box>
);

NewResourceForm.propTypes = {
  form: PropTypes.shape({
    name: PropTypes.string,
    externalId: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

NewResourceForm.defaultProps = {
  loading: false,
};

export default NewResourceForm;
